import { useState } from 'react';

import { useForgotPasswordConfirmMutation } from '@/query/auth.query';

import type { ForgotPasswordConfirmFormValues } from '@/schemas/auth.schema';

import { cn } from '@/lib/utils';

import { ForgotPasswordConfirm } from './forgot-password-confirm';
import { ForgotPasswordRequest } from './forgot-password-request';

interface ForgotPasswordProps {
  className?: string;
  toggle: () => void;
}

export const ForgotPassword = ({ className, toggle }: ForgotPasswordProps) => {
  const [username, setUsername] = useState('');
  const [step, setStep] = useState<'request' | 'confirm'>('request');

  const confirmMutation = useForgotPasswordConfirmMutation({
    onSuccess: () => toggle(),
  });

  const handleConfirmSubmit = (values: ForgotPasswordConfirmFormValues) => {
    confirmMutation.mutate({
      username,
      confirmation_code: values.confirmation_code,
      new_password: values.new_password,
    });
  };

  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {step === 'request' ? (
        <ForgotPasswordRequest
          onSuccess={submittedUsername => {
            setUsername(submittedUsername);
            setStep('confirm');
          }}
          onBack={toggle}
        />
      ) : (
        <ForgotPasswordConfirm
          isLoading={confirmMutation.isPending}
          onSubmit={handleConfirmSubmit}
          onBack={() => setStep('request')}
        />
      )}
    </div>
  );
};
